import { UseCaseTypes } from 'Types/Tasks.types'
import { ITaskConstructor } from './TaskAdapter'
import { TextAnnotationTask } from 'Tasks/TextAnnotationTask/TextAnnotationTask'
import { GenerationTask } from 'Tasks/GenerationTask/GenerationTask'
import { RatingsTask } from 'Tasks/RatingsTask/RatingsTask'
import { SummarisationTask } from 'Tasks/SummarisationTask/SummarisationTask'
import { JSONAnnotationTask } from 'Tasks/JSONAnnotation/JSONAnnotationTask'
import { CustomTask } from 'Tasks/CustomTask/CustomTask'
import { ConversationsTask } from 'Tasks/ConversationsTask/ConversationsTask'
import { ConversationTaskv2 } from 'Tasks/ConversationTaskv2/ConversationTaskv2'
import { AgenticAnnotationTask } from 'Tasks/AgenticAnnotation/AgenticAnnotationTask'
import { CustomInterfaceTask } from 'Tasks/CustomInterfaceTask/CustomInterfaceTask'

type TaskKey = string

export class TaskRegistry {
    private static instance: TaskRegistry
    private tasks: Map<UseCaseTypes, Map<TaskKey, ITaskConstructor>> = new Map()

    private constructor() {
        this.registerBuiltInTasks()
    }

    public static getInstance(): TaskRegistry {
        if (!TaskRegistry.instance) {
            TaskRegistry.instance = new TaskRegistry()
        }
        return TaskRegistry.instance
    }

    public registerTask({
        type,
        taskKey = 'default',
        task,
    }: {
        type: UseCaseTypes
        taskKey?: TaskKey
        task: ITaskConstructor
    }): void {
        if (!this.tasks.has(type)) {
            this.tasks.set(type, new Map())
        }
        this.tasks.get(type)?.set(taskKey, task)
    }

    public getTask({
        type,
        taskKey = 'default',
    }: {
        type: UseCaseTypes
        taskKey?: TaskKey
    }): ITaskConstructor | undefined {
        return this.tasks.get(type)?.get(taskKey)
    }

    public hasTask({
        type,
        taskKey = 'default',
    }: {
        type: UseCaseTypes
        taskKey?: TaskKey
    }): boolean {
        return (this.tasks.has(type) && this.tasks.get(type)?.has(taskKey)) ?? false
    }

    private registerBuiltInTasks() {
        this.registerTask({
            type: UseCaseTypes.SFT_GENERATION_RESPONSE_GENERATION,
            task: GenerationTask,
        })

        this.registerTask({
            type: UseCaseTypes.SFT_GENERATION_RESPONSE_GENERATION_RATING_USECASE,
            task: GenerationTask,
        })

        this.registerTask({
            type: UseCaseTypes.SFT_GENERATION_RESPONSE_GENERATION_SUMMARISATION_USECASE,
            task: SummarisationTask,
        })

        this.registerTask({
            type: UseCaseTypes.RLHF_RATING_RESPONSE_RATING,
            task: RatingsTask,
        })

        this.registerTask({
            type: UseCaseTypes.TEXT_ANNOTATION,
            task: TextAnnotationTask,
        })

        this.registerTask({
            type: UseCaseTypes.CUSTOM,
            task: CustomTask,
        })

        this.registerTask({
            type: UseCaseTypes.JSON_ANNOTATION,
            task: JSONAnnotationTask,
        })

        this.registerTask({
            type: UseCaseTypes.MODEL_CONVERSATIONS,
            task: ConversationsTask,
        })

        this.registerTask({
            type: UseCaseTypes.MODEL_CONVERSATIONS_V2,
            task: ConversationTaskv2,
        })

        this.registerTask({
            type: UseCaseTypes.AGENTIC_TRAJECTORY_CREATION,
            task: AgenticAnnotationTask,
        })

        this.registerTask({
            type: UseCaseTypes.CUSTOM_INTERFACE,
            task: CustomInterfaceTask,
        })

        this.registerTask({
            type: UseCaseTypes.ROBOTICS,
            task: CustomInterfaceTask,
        })
    }
}
